import { render, staticRenderFns } from "./ArticleCompanyDetails.vue?vue&type=template&id=2364e1d8&"
import script from "./ArticleCompanyDetails.vue?vue&type=script&lang=js&"
export * from "./ArticleCompanyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports